<template>
	<div class="export-products">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export Products</h1>
		<p class="description">This will export all the products from the system in CSV format</p>

		<div class="content-wrapper">
			<div class="radioCheck">
				<b-radio v-model="type" name="name" native-value="all">All Products</b-radio>
				<b-radio v-model="type" name="name" native-value="shop">Shop Products</b-radio>
				<b-radio v-model="type" name="name" native-value="histories">Product Histories</b-radio>
			</div>

			<div class="single-text-wrapper" v-if="type == 'histories'">
				<b-field label="BD CODE (single product)" v-if="displayBDCodeInput">
					<b-input v-model="bd_code" placeholder="BD CODE" @keyup.native.enter="exportProducts"></b-input>
				</b-field>

				<div v-if="displayDateSelector">
					<b-field label="Starting Date">
						<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="fromDate" icon="calendar-today">
							<button class="button is-primary" @click="fromDate = new Date()">
								<b-icon icon="calendar-today"></b-icon>
								<span>Today</span>
							</button>

							<button class="button is-danger" @click="fromDate = null">
								<b-icon icon="close"></b-icon>
								<span>Clear</span>
							</button>
						</b-datepicker>
					</b-field>

					<b-field label="Ending Date">
						<b-datepicker
							:date-formatter="dateFormatter"
							placeholder="Click to select..."
							v-model="toDate"
							icon="calendar-today"
							:min-date="minDate"
							:max-date="maxDate"
						>
							<button class="button is-primary" @click="toDate = new Date()">
								<b-icon icon="calendar-today"></b-icon>
								<span>Today</span>
							</button>

							<button class="button is-danger" @click="toDate = null">
								<b-icon icon="close"></b-icon>
								<span>Clear</span>
							</button>
						</b-datepicker>
					</b-field>
				</div>
			</div>

			<b-field label="Select Shop (required)" v-if="displayShopSelection">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<b-field label="Select Brand (Optional)" v-if="displayBrandSelection">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<b-checkbox class="checkbox" v-if="type == 'shop'" v-model="exportForShopImport" :native-value="exportForShopImport"
				>Export for shop import.</b-checkbox
			>
			<b-checkbox class="checkbox" v-if="type == 'shop'" v-model="exportUnsold" :native-value="exportUnsold">Export unsold products only.</b-checkbox>

			<div v-if="exportUnsold == true && type == 'shop'" class="unsold-date-wrapper">
				<b-field label="Starting Date">
					<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="fromDate" icon="calendar-today">
						<button class="button is-primary" @click="fromDate = new Date()">
							<b-icon icon="calendar-today"></b-icon>
							<span>Today</span>
						</button>

						<button class="button is-danger" @click="fromDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button>
					</b-datepicker>
				</b-field>

				<b-field label="Ending Date">
					<b-datepicker
						:date-formatter="dateFormatter"
						placeholder="Click to select..."
						v-model="toDate"
						icon="calendar-today"
						:min-date="minDate"
						:max-date="maxDate"
					>
						<button class="button is-primary" @click="toDate = new Date()">
							<b-icon icon="calendar-today"></b-icon>
							<span>Today</span>
						</button>

						<button class="button is-danger" @click="toDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button>
					</b-datepicker>
				</b-field>
			</div>

			<div class="button-container">
				<div class="big-button" @click="exportProducts()">Export Products</div>
			</div>
			<!-- <div class="total-count" v-if="totalCount > 0">Total Result Found : {{ totalCount.toLocaleString('en-GB') }}</div> -->

			<div v-if="progress > 0">
				<br /><br />
				<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"
					>{{ processCount }} of {{ totalCount.toLocaleString('en-GB') }}</b-progress
				>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ExportProducts',
	data: function() {
		return {
			isLoading: false,
			total: 0,
			limit: 100,
			shopLimit: 100,
			bd_code: null,
			totalLoop: 0, // To store how many times to loop in total
			loopCount: 0, // Count how many to loop
			products: [], // To store products
			brands: [], // To store brands
			selectedBrand: null,
			brandSuggestions: '',
			totalCount: 0,
			type: 'all',
			shops: [], // For list of shops from API
			shopsSuggestions: '', // For dropdown selection
			selectedShop: null, // Selected shop
			displayShopSelection: false,
			displayBrandSelection: true,
			processCount: 0,
			progress: 0,
			fromDate: null,
			toDate: null,
			displayDateSelector: true,
			displayBDCodeInput: true,
			minDate: null,
			maxDate: null,
			exportForShopImport: false,
			exportUnsold: false,
			histories: []
		}
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	watch: {
		// To display or hide brand selection
		type: function(newData) {
			if (newData == 'histories') {
				this.displayBrandSelection = false
			} else {
				this.displayBrandSelection = true
			}

			if (newData == 'shop') {
				this.displayShopSelection = true
			} else {
				this.displayShopSelection = false
			}
		},

		bd_code: function(data) {
			if (data == null || data == '') {
				this.displayDateSelector = true
			} else {
				this.displayDateSelector = false
			}
		},

		fromDate: function(data) {
			if (data == null || data == '') {
				this.displayBDCodeInput = true
				this.toDate = null
			} else {
				this.minDate = data
				this.toDate = data

				this.displayBDCodeInput = false

				this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)
			}
		}
	},

	mounted: async function() {
		await this.getBrands()

		await this.getShops()
	},

	methods: {
		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		exportShopProducts: async function() {
			// const compo = this
			var data = {}

			if (this.exportForShopImport == false && this.exportUnsold == true) {
				data = {
					shop: this.selectedShop._id,
					time: {
						createdAt: {
							$gte: this.$moment(this.fromDate)
								.set({ hour: 0 })
								.format('x'),
							$lte: this.$moment(this.toDate)
								.set({ hour: 23 })
								.format('x')
						}
					}
				}

				if (this.selectedBrand !== null && this.selectedBrand._id !== 'all') {
					data.refs = {
						product: {
							brand: this.selectedBrand._id
						}
					}
				}

				const unsoldProducts = await this.$api.exportUnsoldProducts({ data })

				if (unsoldProducts) {
					this.$swal.fire({
						icon: 'success',
						title: 'Success!',
						text: 'System will email to you once process is completed.'
					})

					this.isLoading = false
				}

				// let finalData = ''

				// finalData += 'UNSOLD PRODUCTS\r\n'
				// finalData += 'SHOP,' + this.selectedShop.name + '\r\n'
				// finalData +=
				// 	'DATE FROM,' + this.$moment(this.fromDate).format('DD MMM YY') + ',TO,' + this.$moment(this.toDate).format('DD MMM YY') + '\r\n\r\n'

				// finalData += 'BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,PURCHASE PRICE,SELLING PRICE,COMMISSION,PRODUCT CODE, CREATED AT\r\n'

				// // total_products.map(p => {
				// for (const p of unsoldProducts.data) {
				// 	if (p) {
				// 		let refsProduct = p

				// 		const matchedBrand = this.brands.filter(brand => {
				// 			return brand._id == refsProduct.brand
				// 		})

				// 		const toAdd = [
				// 			refsProduct.bd_code,
				// 			refsProduct.barcode,
				// 			'"' + refsProduct.name + '"',
				// 			matchedBrand[0].name,
				// 			matchedBrand[0].code,
				// 			refsProduct.original_price,
				// 			refsProduct.price,
				// 			refsProduct.commission,
				// 			refsProduct.product_code,
				// 			this.convertTime(refsProduct.createdAt)
				// 		]

				// 		let row = toAdd.join(',')

				// 		finalData += row + '\r\n'
				// 	}
				// }

				// const csvData = new Blob([finalData], { type: 'text/csv' }) //new way
				// const csvUrl = URL.createObjectURL(csvData)

				// const link = document.createElement('a')
				// link.setAttribute('href', csvUrl)
				// link.setAttribute('download', this.selectedShop.name + '_Export_Products.csv')
				// document.body.appendChild(link) // Required for FF

				// this.isLoading = false

				// link.click()
				// link.remove()

				// this.isLoading = false

				return
			}

			data = {
				limit: 1,
				shop: this.selectedShop._id
			}

			if (this.selectedBrand !== null && this.selectedBrand._id !== 'all') {
				data.refs = {
					product: {
						brand: this.selectedBrand._id
					}
				}
			}

			const apiExportProducts = await this.$api.shopProduct({ data })

			this.total = apiExportProducts.data.total
			this.totalLoop = Math.ceil(apiExportProducts.data.total / this.shopLimit)

			if (apiExportProducts !== undefined && apiExportProducts.data.total > 0) {
				this.totalCount = apiExportProducts.data.total
			} else {
				this.isLoading = false
				this.$swal.fire({
					icon: 'info',
					title: 'Oops...',
					text: 'Nothing found!'
				})

				return
			}

			var i
			var skip
			const parallel = []

			for (i = 0; i < this.totalLoop; i++) {
				// for (i = 0; i < 5; i++) {
				skip = i * this.shopLimit

				this.processCount = skip
				this.progress = (this.processCount / this.total) * 100

				data = {
					shop: this.selectedShop._id,
					limit: this.shopLimit,
					skip
				}

				if (this.selectedBrand !== null && this.selectedBrand._id !== 'all') {
					data.refs = {
						product: {
							brand: this.selectedBrand._id
						}
					}
				}

				var result = await this.getShopProductsLoop(data)
				parallel.push(result)
			}

			const total_result = await Promise.all(parallel)

			const total_products = {}

			total_result.map(result => {
				const { list } = result.data

				list.map(product => {
					const productId = product.product

					if (!total_products[productId]) {
						total_products[productId] = product
					} else {
						console.log(total_products[productId].refs.product.bd_code)
					}
				})
			})

			// total_products.sort((a, b) => {
			// 	const aTime = compo
			// 		.$moment(a.createdAt)
			// 		.toDate()
			// 		.getTime()
			// 	const bTime = compo
			// 		.$moment(b.createdAt)
			// 		.toDate()
			// 		.getTime()

			// 	return aTime - bTime
			// })

			let finalData = ''

			if (this.exportForShopImport == true) {
				finalData += '_id,price,stock,status,bd_code,barcode,name,product_code,brand,commission,original_price,author\r\n'

				// total_products.map(p => {
				for (const p in total_products) {
					if (total_products[p].product && total_products[p].refs) {
						let refsProduct = total_products[p].refs.product

						// const matchedBrand = this.brands.filter(brand => {
						// 	return brand._id == refsProduct.brand
						// })

						const toAdd = [
							refsProduct._id,
							refsProduct.price,
							total_products[p].stock,
							total_products[p].status,
							refsProduct.bd_code,
							refsProduct.barcode,

							'"' + refsProduct.name.replace(/(\r\n|\n|\r)/gm, '') + '"',
							refsProduct.product_code,
							refsProduct.brand,
							refsProduct.commission,
							refsProduct.original_price,
							refsProduct.author
						]

						let row = toAdd.join(',')

						finalData += row + '\r\n'
					}
				}
			} else {
				finalData += 'BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,PURCHASE PRICE,SELLING PRICE,COMMISSION,PRODUCT CODE,STOCK, CREATED AT\r\n'

				// total_products.map(p => {
				for (const p in total_products) {
					if (total_products[p].product && total_products[p].refs) {
						let refsProduct = total_products[p].refs.product

						const matchedBrand = this.brands.filter(brand => {
							return brand._id == refsProduct.brand
						})

						const toAdd = [
							refsProduct.bd_code,
							refsProduct.barcode,
							'"' + refsProduct.name + '"',
							matchedBrand[0].name,
							matchedBrand[0].code,
							refsProduct.original_price,
							refsProduct.price,
							refsProduct.commission,
							refsProduct.product_code,
							total_products[p].stock,
							this.convertTime(refsProduct.createdAt)
						]

						let row = toAdd.join(',')

						finalData += row + '\r\n'
					}
				}
			}

			// )

			var csvData = new Blob([finalData], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', this.selectedShop.name + '_Export_Products.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()
		},

		exportHistories: async function() {
			if (this.bd_code !== null) {
				let product_data = {
					bd_code: this.bd_code
				}

				const apiGetProduct = await this.$api.getProductDetail({ data: product_data })

				if (!apiGetProduct || !apiGetProduct.data) {
					this.$swal.fire({
						icon: 'info',
						title: 'Oops...',
						text: 'BD Code not found!'
					})

					this.isLoading = false

					return
				}

				let data = {
					limit: 100,
					product: {
						id: apiGetProduct.data._id
					},
					populate: ['product.author'],
					sort: {
						createdAt: 'asc'
					}
				}

				const apiProductHistories = await this.$api.productHistory({ data })

				if (apiProductHistories && apiProductHistories.data.count > 0) {
					let histories = apiProductHistories.data.list

					let csv = ''

					csv += 'BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,PURCHASE PRICE,SELLING PRICE,COMMISSION,PRODUCT CODE,AUTHOR,CREATED AT\r\n'

					histories.map(history => {
						let product = history.product

						const matchedBrand = this.brands.filter(brand => {
							return brand._id == product.brand
						})

						const toAdd = [
							product.bd_code,
							product.barcode,
							'"' + product.name + '"',
							matchedBrand[0].name,
							matchedBrand[0].code,
							product.original_price,
							product.price,
							product.commission,
							product.product_code,
							product.author.name,
							this.convertTime(history.createdAt)
						]

						let row = toAdd.join(',')

						csv += row + '\r\n'
					})

					let csvData = new Blob([csv], { type: 'text/csv' }) //new way
					let csvUrl = URL.createObjectURL(csvData)

					let link = document.createElement('a')
					link.setAttribute('href', csvUrl)
					link.setAttribute('download', this.bd_code + '_Export_Products_Histories.csv')
					document.body.appendChild(link) // Required for FF

					this.isLoading = false

					link.click()
					link.remove()
				} else {
					this.$swal.fire({
						icon: 'info',
						title: 'Oops...',
						text: 'NO Histories found for selected BD Code'
					})
				}

				this.isLoading = false
			} else {
				// For exporting with date range
				this.histories = []

				let data = {
					limit: 100,
					populate: ['product.author'],
					time: {
						createdAt: {
							$gte: this.$moment(this.fromDate)
								.set({ hour: 0 })
								.format('x'),
							$lte: this.$moment(this.toDate)
								.set({ hour: 23 })
								.format('x')
						}
					},
					sort: {
						createdAt: 'asc'
					}
				}

				const apiHistories = await this.$api.productHistory({ data })

				if (apiHistories && apiHistories.data && apiHistories.data.total > 0) {
					apiHistories.data.list.map(history => {
						this.histories.push(history)
					})
				} else {
					this.$swal.fire({
						icon: 'info',
						title: 'Oops...',
						text: 'No data found!'
					})

					this.isLoading = false

					return
				}

				// Loop if result is more than 100
				if (apiHistories.data.total > 100) {
					let totalLoop = Math.ceil(apiHistories.data.total / 100)

					var i
					var skip

					for (i = 1; i < totalLoop; i++) {
						skip = i * 100

						data.skip = skip

						const histories = await this.$api.productHistory({ data })

						if (histories && histories.data) {
							histories.data.list.map(history => {
								this.histories.push(history)
							})
						}
					}
				}

				let csv = 'BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,PURCHASE PRICE,SELLING PRICE,COMMISSION,PRODUCT CODE,AUTHOR,CREATED AT\r\n'

				this.histories.map(history => {
					let product = history.product

					const matchedBrand = this.brands.filter(brand => {
						return brand._id == product.brand
					})

					const toAdd = [
						product.bd_code,
						product.barcode,
						'"' + product.name + '"',
						matchedBrand[0].name,
						matchedBrand[0].code,
						product.original_price,
						product.price,
						product.commission,
						product.product_code,
						product.author.name,
						this.convertTime(history.createdAt)
					]

					let row = toAdd.join(',')

					csv += row + '\r\n'
				})

				let csvData = new Blob([csv], { type: 'text/csv' }) //new way
				let csvUrl = URL.createObjectURL(csvData)

				let filename_date = this.$moment().format('DDMMYYhhmmss')

				let link = document.createElement('a')
				link.setAttribute('href', csvUrl)
				link.setAttribute('download', 'Export_Products_Histories_' + filename_date + '.csv')
				document.body.appendChild(link) // Required for FF

				link.click()
				link.remove()

				this.isLoading = false
			}
		},

		// Export products on user click
		exportProducts: async function() {
			this.totalCount = 0
			this.processCount = 0
			this.progress = 0
			this.isLoading = true
			const compo = this

			if (this.type == 'histories') {
				if ((this.bd_code == null || this.bd_code == '') && this.fromDate == null) {
					this.$swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: 'At least BD Code or Date range are required!'
					})
					this.isLoading = false
					return
				}

				this.exportHistories()
				return
			}

			// If this is for shop, redirect to shop product export function
			if (this.type == 'shop' && !this.selectedShop) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Please select a shop!'
				})

				this.isLoading = false

				return
			} else if (this.type == 'shop' && this.exportUnsold && (!this.fromDate || !this.toDate)) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Please select starting date and ending date!'
				})

				this.isLoading = false

				return
			} else if (this.type == 'shop' && this.selectedShop) {
				this.exportShopProducts()

				return
			}

			var data = {
				limit: 1
			}

			if (this.selectedBrand !== null && this.selectedBrand._id !== 'all') {
				data.brand = this.selectedBrand._id
			}

			const apiExportProducts = await this.$api.getProducts({ data })

			this.total = apiExportProducts.data.total
			this.totalLoop = Math.ceil(apiExportProducts.data.total / this.limit)

			if (apiExportProducts !== undefined && apiExportProducts.data.total > 0) {
				this.totalCount = apiExportProducts.data.total
			} else {
				this.isLoading = false
				this.$swal.fire({
					icon: 'info',
					title: 'Oops...',
					text: 'Nothing found!'
				})

				return
			}

			var i
			var skip
			const parallel = []

			for (i = 0; i < this.totalLoop; i++) {
				// for (i = 0; i < 7; i++) {
				skip = i * this.limit
				this.processCount = skip
				this.progress = (this.processCount / this.total) * 100

				data = {
					limit: this.limit,
					skip
				}

				if (this.selectedBrand !== null && this.selectedBrand._id !== 'all') {
					data.brand = this.selectedBrand._id
				}

				var result = await this.getProductsLoop(data)
				parallel.push(result)
			}

			const total_result = await Promise.all(parallel)

			const total_products = []

			total_result.map(result => {
				const { list } = result.data

				list.map(product => {
					total_products.push(product)
				})
			})

			total_products.sort((a, b) => {
				const aTime = compo
					.$moment(a.createdAt)
					.toDate()
					.getTime()
				const bTime = compo
					.$moment(b.createdAt)
					.toDate()
					.getTime()

				return aTime - bTime
			})

			let finalData = ''

			finalData += 'BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,PURCHASE PRICE,SELLING PRICE,COMMISSION,PRODUCT CODE, CREATED AT\r\n'

			total_products.map(p => {
				if (p.bd_code) {
					const matchedBrand = this.brands.filter(brand => {
						return brand._id == p.brand
					})

					const toAdd = [
						p.bd_code,
						p.barcode,
						'"' + p.name + '"',
						matchedBrand[0].name,
						matchedBrand[0].code,
						p.original_price,
						p.price,
						p.commission,
						p.product_code,
						this.convertTime(p.createdAt)
					]

					let row = toAdd.join(',')

					finalData += row + '\r\n'
				}
			})

			var csvData = new Blob([finalData], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Export_Products.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()
		},

		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 2000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list
				this.brands.unshift({ code: 'ALL', name: 'ALL', _id: 'all' })
			}
		},

		getProductsLoop: async function(data) {
			return await this.$api.getProducts({ data })
		},

		getShopProductsLoop: async function(data) {
			return await this.$api.shopProduct({ data })
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YYYY')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
